import React from 'react';

const AssetRegistry = () => {
  return (
    <div className="jo-xyz-demo-asset-registry-page">
      <div className="jo-xyz-demo-container">
        <h1>Asset Registry</h1>
        <p>Asset management and monitoring functionality coming soon...</p>
      </div>
    </div>
  );
};

export default AssetRegistry;
